<template>
  <div class="show-data-node" >
    <div class="header">
      <el-page-header @back="handleModalCancel" :content="dataNode.name + '-详情页面'">
      </el-page-header>
    </div>
    <el-row type="flex" class="data-node-detail-container">
      <el-col class="chart-container" :span="6">
        <div class="image-block">
          <!--              <span class="demonstration">现场图片</span>-->
          <el-image ref="dataNodeImage" :src="imageFileName" fit="scale-down">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
      </el-col>
      <el-col class="chart-container" :span="18">
        <el-table :data="tableData"
                  ref="table"
                  :show-header="false"
                  :highlight-current-row="false"
                  border element-loading-background="rgba(255, 255, 255, 0.8)"
                  element-loading-spinner="el-icon-loading"
                  element-loading-text="努力加载中..."
                  style="width: 100%"
                  :cell-style="handleTableCellStyleChange"
                  :cell-class-name="handleTableCellClassChange">
          <el-table-column prop="1"></el-table-column>
          <el-table-column prop="2"></el-table-column>
          <el-table-column prop="3"></el-table-column>
          <el-table-column prop="4"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--实时数据、历史数据、事件记录、统计分析等内容-->
    <el-tabs v-model="activeTabName" class="data-node-detail-container2" @tab-click="handleTabClick">
      <el-tab-pane label="实时数据" name="0">
        <el-row type="flex">
          <el-col class="chart-container" :span="12">
            <div class="chart-title">列表</div>
            <el-table :data="dataTableData"
                      ref="dataNodeDataTable"
                      stripe border highlight-current-row
                      element-loading-background="rgba(255, 255, 255, 0.8)"
                      element-loading-spinner="el-icon-loading"
                      element-loading-text="努力加载中..."
                      style="width: 100%;height: calc(100% - 40px)">
              <el-table-column label="序号" type="index" width="60"></el-table-column>
              <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="数值" prop="workStateText" width="100"></el-table-column>
              <el-table-column label="告警状态" prop="alarmState" width="80">
                <template slot-scope="scope">
                  <el-tag :type="tagTypeFromResourceAlarmState(scope.row.resourceKind, scope.row.alarmState, scope.row.eventTypeSet, 1, 0, 0)">
                    {{$type.getResourceAlarmStateText(scope.row.resourceKind, scope.row.alarmState, scope.row.eventTypeSet, 1, 0, 0)}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="事件类型" prop="eventTypeText" width="120"></el-table-column>
              <el-table-column label="事件子类型" prop="eventSubTypeText" width="120"></el-table-column>
              <el-table-column label="数值更新时间" prop="reporttime" width="160">
                <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.reportTime)}}</template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col class="chart-container" :span="12">
            <div class="chart-title">图表</div>
            <LineChart
              ref="dataLineChart"
              :id="dataLineChartId"
              :source="dataLineChartData"
              :color="dataLineChartColor"
              style="width:100%; height:calc(100% - 40px); min-height: 300px"
            ></LineChart>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="历史数据" name="1">
        <el-form ref="historyDataQueryForm" class="pagination-history-data-table-query-form" :inline="true"
                 @keyup.enter.native="handleHistoryDataFormQuery()">
          <el-form-item label="日期时间">
            <uni-date-picker
              v-model="historyDataDate"
              type="date">
            </uni-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleHistoryDataFormQuery()" type="primary">查 询</el-button>
            <el-button @click="handlePriorDayHistoryDataFormQuery()">前一天</el-button>
            <el-button @click="handleNextDayHistoryDataFormQuery()">后一天</el-button>
            <el-button @click="resetHistoryDataQueryForm()">重 置</el-button>
          </el-form-item>
        </el-form>
        <el-row type="flex">
          <el-col class="chart-container" :span="12">
            <div class="chart-title">列表</div>
            <el-table :data="historyDataTableData"
                      ref="historyDataNodeDataTable"
                      v-loading="loading"
                      border highlight-current-row
                      element-loading-background="rgba(255, 255, 255, 0.8)"
                      element-loading-spinner="el-icon-loading"
                      element-loading-text="努力加载中..."
                      style="width: 100%">
              <el-table-column label="序号" type="index" width="60"></el-table-column>
              <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="数值" prop="workStateText" width="100"></el-table-column>
              <el-table-column label="告警状态" prop="alarmState" width="80">
                <template slot-scope="scope">
                  <el-tag :type="tagTypeFromResourceAlarmState(scope.row.resourceKind, scope.row.alarmState, scope.row.eventTypeSet, 1, 0, 0)">
                    {{$type.getResourceAlarmStateText(scope.row.resourceKind, scope.row.alarmState, scope.row.eventTypeSet, 1, 0, 0)}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="事件类型" prop="eventTypeText" width="120"></el-table-column>
              <el-table-column label="事件子类型" prop="eventSubTypeText" width="120"></el-table-column>
              <el-table-column label="数值更新时间" prop="reporttime" width="160">
                <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.reportTime)}}</template>
              </el-table-column>
            </el-table>
            <el-pagination v-show="historyDataTableTotalRow > historyDataTableQueryParams.pageSize"
              small
              @current-change="handleHistoryDataCurrentPageChange"
              :current-page.sync="historyDataTableQueryParams.pageNum"
              :page-size.sync="historyDataTableQueryParams.pageSize"
              layout="total, prev, pager, next"
              :total="historyDataTableTotalRow">
            </el-pagination>
          </el-col>
          <el-col class="chart-container" :span="12">
            <div class="chart-title">图表
              <el-button style="float:right;width:50px;height:17px;line-height:17px;padding:0" @click="handleAddDataNode">对比</el-button>
            </div>
            <LineChart
              ref="historyDataLineChart"
              :id="historyDataLineChartId"
              :source="historyDataLineChartData"
              :color="dataLineChartColor"
              :gridBottom="60 + 20 * (addDataNodes.length / 5)"
              style="width:100%; height:calc(100% - 40px); min-height: 280px"
            ></LineChart>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="事件记录" name="2">
        <el-form ref="historyEvnetQueryForm" class="pagination-history-event-table-query-form" :inline="true"
                 @keyup.enter.native="handleHistoryEventFormQuery()">
          <el-form-item label="事件触发时间">
            <uni-date-range-picker
              v-model="eventDates"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </uni-date-range-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleHistoryEventFormQuery()" type="primary">查 询</el-button>
            <el-button @click="resetHistoryEventQueryForm()">重 置</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="eventTableData"
                  ref="dataNodeEventTable"
                  stripe border highlight-current-row
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                  element-loading-spinner="el-icon-loading"
                  element-loading-text="努力加载中..."
                  style="width: 100%"
                  @selection-change="handleEventTableSelectionChange"
                  @current-change="handleEventTableCurrentChange">
          <!--          <el-table-column type="selection" width="40"></el-table-column>-->
          <el-table-column label="序号" type="index" width="60"></el-table-column>
          <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
            <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>
          </el-table-column>
          <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="告警状态" prop="alarmState" width="90">
            <template slot-scope="scope">
              <el-tag :type="scope.row.alarmState === 1 ? 'danger'
                  : scope.row.alarmState === 2 ? 'warning'
                  :'primary'">
                {{scope.row.alarmStateText}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="告警级别" prop="alarmLevel" width="100">
            <template slot-scope="scope">{{ getNameById(scope.row.alarmLevel, $type.alarmLevels) }}</template>
          </el-table-column>
          <el-table-column label="数值" prop="workStateText" width="100"></el-table-column>
          <el-table-column label="事件类型" prop="eventTypeText" width="120"></el-table-column>
          <el-table-column label="事件子类型" prop="eventSubTypeText" width="120"></el-table-column>
          <el-table-column label="事件触发时间" prop="happenTime" width="160">
            <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>
          </el-table-column>
          <el-table-column label="正常区间" prop="alarmRuleText" width="100"></el-table-column>
          <el-table-column label="确认状态" prop="handled" width="80">
            <template slot-scope="scope">
              <el-tag :type="(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1 || scope.row.handled === 1) ? 'primary':'warning'">
                {{(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1) ? '--' : getNameById(scope.row.handled, $type.handleStates)}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130">
            <template slot-scope="scope">
              <el-button
                class="col-btn"
                type="text"
                icon="el-icon-view"
                @click="handleEventView(scope.row)"
              >查看
              </el-button>
              <el-button
              class="col-btn"
              type="text"
              icon="el-icon-s-check"
              :disabled="scope.row.alarmLevel === 0 || scope.row.alarmState !== 1 || scope.row.handled === 1"
              @click="handleEventHandle(scope.row)"
            >确认
            </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="eventTableTotalRow > eventTableQueryParams.pageSize"
                       small
                       @current-change="handleEventCurrentPageChange"
                       :current-page.sync="eventTableQueryParams.pageNum"
                       :page-size.sync="eventTableQueryParams.pageSize"
                       layout="total, prev, pager, next"
                       :total="eventTableTotalRow">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="统计分析" name="3">
        <el-row type="flex">
          <el-col class="chart-container" :span="24">
            <div class="chart-title">平均值 | 最大值 | 最小值</div>
            <LineChart
              ref="statisticsLineChart"
              :id="statisticsLineChartId"
              :source="statisticsLineChartData"
              :color="statisticsLineChartColor"
              style="width:100%; height:calc(100% - 40px); min-height: 420px"
            ></LineChart>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <!--增加数据节点-->
    <add-data-node v-if="addDataNodeModalOpen" :modalOpen="addDataNodeModalOpen" :regionId="dataNode.regionId" @submit="handleAddDataNodeModalSubmit" @cancel="handleAddDataNodeModalCancel"></add-data-node>

    <!--显示告警事件信息-->
    <show-alarm-event v-if="showEventModalOpen" :modalOpen="showEventModalOpen" :alarmEvent="eventTableCurrentRow" @submit="handleShowEventModalSubmit" @cancel="handleShowEventModalCancel"></show-alarm-event>

    <!--确认告警事件弹窗-->
    <handle-alarm-event-Modal v-if="handelAlarmEventModalOpen" :modalOpen="handelAlarmEventModalOpen" :alarmEvent="eventTableCurrentRow" @submit="handleHandleAlarmEventModalSubmit" @cancel="handleHandleAlarmEventModalCancel"></handle-alarm-event-Modal>

  </div>
</template>

<script type="text/ecmascript-6">
import ShowDataNode from './ShowDataNode.js'
export default ShowDataNode
</script>

<style lang="scss">
  @import "ShowDataNode";
</style>



// WEBPACK FOOTER //
// src/views/common/showDataNode/ShowDataNode.vue